import { isNotArchived } from '@griply/utils';
import { useMemo } from 'react';
import { useToday } from 'shared/contexts/today';

import { useTasks } from './use-tasks';

export const useTodaysCompletedTasks = () => {
  const today = useToday();
  // Its own subscription, not the shared unbounded completed sub: the server
  // `completedAt >= today` constraint is what enforces the window.
  const completedTasks = useTasks({ completedAt: today });

  // Timeslot (`action`) tasks stay in — the uncompleted list shows them too.
  return useMemo(
    () =>
      completedTasks.filter(
        (task) => !task.parentIds?.length && isNotArchived(task),
      ),
    [completedTasks],
  );
};
